<template>
    <button
        v-tippy="t('editorToggleTextAlignJustify')"
        :class="[
            buttonState(true, editor.isActive({ textAlign: 'justify' })),
            'flex-none rounded p-1 text-sm',
        ]"
        @click="editor.chain().focus().setTextAlign('justify').run()"
    >
        <MdiFormatAlignJustify class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatAlignJustify from 'materialdesignicons-vue3/icons/MdiFormatAlignJustify.js';

    defineExpose({
        name: 'TextAlignJustifyButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
